module.exports = __webpack_public_path__ + "img/img_title_advantage_05.e1cbc0d2.png";